<template>
  <svg
    v-if="!isSmall"
    width="17"
    height="13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.375 3.243c0 .26-.092.504-.275.687l-8.287 8.296c-.183.183-.442.29-.702.29a.998.998 0 01-.687-.29L.9 6.696a.958.958 0 01-.275-.688c0-.26.092-.52.275-.703L2.289 3.93a.97.97 0 01.686-.29.97.97 0 01.687.29l3.45 3.453 6.226-6.218a.97.97 0 01.687-.29.97.97 0 01.686.29l1.39 1.375a.994.994 0 01.274.703z"
      fill="#fff"
    />
  </svg>

  <svg
    v-else
    width="17"
    height="13"
    viewBox="0 -1 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.375 3.243c0 .26-.092.504-.275.687l-8.287 8.296c-.183.183-.442.29-.702.29a.998.998 0 01-.687-.29L.9 6.696a.958.958 0 01-.275-.688c0-.26.092-.52.275-.703L2.289 3.93a.97.97 0 01.686-.29.97.97 0 01.687.29l3.45 3.453 6.226-6.218a.97.97 0 01.687-.29.97.97 0 01.686.29l1.39 1.375a.994.994 0 01.274.703z"
      fill="#fff"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isSmall: {
      type: Boolean,
      default: false
    }
  }
};
</script>
